import React, { useState } from "react";
import axios from "axios";
import HeaderService from "../components/layout/header/HeaderService";
import { ClipLoader } from "react-spinners";
import Footer1 from "../components/layout/footer/Footer1";

export default function Contact1() {
    const [formData, setFormData] = useState({
        referralType: "",
        refFirstName: "",
        refLastName: "",
        refPhone: "",
        refEmail: "",
        refRelationship: "",
        clientFirstName: "",
        clientLastName: "",
        clientDOB: "",
        clientStreet: "",
        clientSuburb: "",
        clientState: "",
        clientPostcode: "",
        clientPhone: "",
        clientEmail: "",
        clientMedical: "",
        clientService: "",
        primaryContact: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setSending(true);
            // console.log("Submitting referral with data:", formData);
            const response = await axios.post("https://server.newranss.com.au/referrels", formData);
            // alert("Referral submitted successfully!");
            setSending(false);
        } catch (error) {
            console.error("Error submitting referral:", error);
            alert("Failed to submit referral.");
        }
    };

    const [sending,setSending] = useState(false);

    return (
        <>
           <HeaderService />
        <section className="contact-1-section pt-lg-0">
            <div className="auto-container">
                <div className="row align-items-start">
                    <div className="col-12">
                        <div className="section_heading mb_30">
                            <h2 className="section_heading_title_big">Submit a Referral</h2>
                        </div>
                        <div className="mb-4">
    <h5 style={{ fontWeight: 'bold', color: '#1a1a1a' }}>🎁 Refer and Be Rewarded! Receive $100/- gift card for every successful Participant you refer to us</h5>
    <p>Help someone access the care they need — and enjoy a reward in return. Submit a referral today and become part of the support journey.</p>
</div>

                        {/* Referral Type Selection */}
                        <div className="mb-4">
                            <label><strong>Referral Type:</strong></label><br />
                            <label><input type="radio" name="referralType" value="NDIS" onChange={handleChange} /> NDIS Referral</label> &nbsp;
                            <label><input type="radio" name="referralType" value="Private" onChange={handleChange} /> Private Referral</label> &nbsp;
                            <label><input type="radio" name="referralType" value="HomeCare" onChange={handleChange} /> Home Care Package Referral</label>
                        </div>

                        <form onSubmit={handleSubmit}>
                            {/* Referrer Details */}
                           <h4>Referrer’s Details</h4>
<div className="row">
    <div className="form-group col-md-6">
        <label htmlFor="refFirstName">First Name</label>
        <input type="text" name="refFirstName" id="refFirstName" placeholder="First Name" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="refLastName">Last Name</label>
        <input type="text" name="refLastName" id="refLastName" placeholder="Last Name" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="refPhone">Phone Number</label>
        <input type="text" name="refPhone" id="refPhone" placeholder="Phone Number" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="refEmail">Email Address</label>
        <input type="email" name="refEmail" id="refEmail" placeholder="Email Address" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-12">
        <label htmlFor="refRelationship">Relationship to Participant</label>
        <input type="text" name="refRelationship" id="refRelationship" placeholder="Relationship to Participant" required onChange={handleChange} />
    </div>
</div>

                            <hr className="my-4" />

                            {/* Client Details */}
                            <h4>Client Details</h4>
<div className="row">
    <div className="form-group col-md-6">
        <label htmlFor="clientFirstName">First Name</label>
        <input type="text" name="clientFirstName" id="clientFirstName" placeholder="First Name" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientLastName">Last Name</label>
        <input type="text" name="clientLastName" id="clientLastName" placeholder="Last Name" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientDOB">DOB</label>
        <input type="text" name="clientDOB" placeholder="DOB (DD/MM/YYYY)" id="clientDOB" required onChange={handleChange} className="form-control" />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientStreet">Street Address</label>
        <input type="text" name="clientStreet" id="clientStreet" placeholder="Street Address" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-4">
        <label htmlFor="clientSuburb">Suburb</label>
        <input type="text" name="clientSuburb" id="clientSuburb" placeholder="Suburb" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-4">
        <label htmlFor="clientState">State</label>
        <input type="text" name="clientState" id="clientState" placeholder="State" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-4">
        <label htmlFor="clientPostcode">Postcode</label>
        <input type="text" name="clientPostcode" id="clientPostcode" placeholder="Postcode" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientPhone">Phone Number</label>
        <input type="text" name="clientPhone" id="clientPhone" placeholder="Phone Number" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientEmail">Email Address</label>
        <input type="email" name="clientEmail" id="clientEmail" placeholder="Email Address" required onChange={handleChange} />
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientMedical">Relevant Medical History</label>
        <textarea name="clientMedical" id="clientMedical" placeholder="Relevant Medical History" onChange={handleChange}></textarea>
    </div>
    <div className="form-group col-md-6">
        <label htmlFor="clientService">Service Requested</label>
        <textarea name="clientService" id="clientService" placeholder="Service Requested" onChange={handleChange}></textarea>
    </div>
</div>
                            <hr className="my-4" />

                            {/* Primary Contact Detail */}
                            <div className="mb-4">
                                <label><strong>Primary Contact Details:</strong></label><br />
                                <label><input type="radio" name="primaryContact" value="Referrer" onChange={handleChange} /> Referrer’s Details</label> &nbsp;
                                <label><input type="radio" name="primaryContact" value="Participant" onChange={handleChange} /> Participant Details</label> &nbsp;
                                <label><input type="radio" name="primaryContact" value="Other" onChange={handleChange} /> Other</label>
                            </div>

                            { sending ? (
                                <ClipLoader/>) : (

                                    
                                    <button className="btn-1 btn-small" type="submit" style={{marginBottom : '20px'}}>Submit now <i className="flaticon-right-arrow-1"></i><span></span></button>
                                )}
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer1 style = {{marginTop: '20px'}}/>
        </>
    );
}
